import React from 'react';
import PropTypes from 'prop-types';
import { isBot } from 'utils/stringUtils';
import MixPanel from 'utils/mixpanelService';
import Hidden from '@material-ui/core/Hidden';
import Grid from '@material-ui/core/Grid';
import ButtonBase from '@material-ui/core/ButtonBase';
import { withStyles } from '@material-ui/core/styles';
import ClassNames from 'classnames';
import AppsInactive from 'components/Resources/images/Black/Apps.svg';
import AppsActive from 'components/Resources/images/Blue/Apps.svg';
import BooksInactive from 'components/Resources/images/Black/Books.svg';
import BooksActive from 'components/Resources/images/Blue/Books.svg';
import VideosInactive from 'components/Resources/images/Black/Videos.svg';
import VideosActive from 'components/Resources/images/Blue/Videos.svg';
import PodcastsInactive from 'components/Resources/images/Black/Podcasts.svg';
import PodcastsActive from 'components/Resources/images/Blue/Podcasts.svg';
import ArticlesInactive from 'components/Resources/images/Black/Articles.svg';
import ArticlesActive from 'components/Resources/images/Blue/Articles.svg';
import ProgramsActive from 'components/Resources/images/Blue/Programs.svg';
import ProgramsInactive from 'components/Resources/images/Black/Programs.svg';
import AllActive from '../images/check-active.svg';
import AllInActive from '../images/check-inactive.svg';
import AssessmentsActive from '../images/assessments-active.svg';
import AssessmentsInactive from '../images/assessments-inactive.svg';
import ResourcesTypeSelector from './ResourcesTypeSelector';
const styles = theme => ({
  root: {
    marginTop: 30,
    marginBottom: 33,
  },
  listWrapper: {
    margin: 0,
    padding: 0,
    listStyle: 'none',
    display: 'flex',
  },
  btn: {
    ...theme.typography.body2,
    margin: '0 20px',
    [theme.breakpoints.between('sm', 'md')]: {
      margin: '0 10px',
      ...theme.typography.overline,
    },
  },
  icon: {
    marginRight: 12,
  },
  activeBtn: {
    ...theme.typography.subtitle1,
    color: theme.palette.text.secondary,
  },
  activeMenu: {
    background: `radial-gradient(farthest-side, #0862C0 98%,transparent 100%) bottom right/4px 4px, radial-gradient(farthest-side, #0862C0 98%,transparent 100%) bottom left /4px 4px, linear-gradient(#0862C0,#0862C0) bottom/calc(100% - 4px) 4px`,
    backgroundRepeat: 'no-repeat',
    paddingBottom: 20,
  },
});

const Menu = [
  {
    label: 'Assessments',
    icon: [AssessmentsActive, AssessmentsInactive],
  },
  {
    label: 'Apps',
    icon: [AppsActive, AppsInactive],
  },
  {
    label: 'Books',
    icon: [BooksActive, BooksInactive],
  },
  {
    label: 'Videos',
    icon: [VideosActive, VideosInactive],
  },
  {
    label: 'Podcasts',
    icon: [PodcastsActive, PodcastsInactive],
  },
  {
    label: 'Articles',
    icon: [ArticlesActive, ArticlesInactive],
  },
  {
    label: 'Online Programs',
    icon: [ProgramsActive, ProgramsInactive],
  },
  {
    label: 'All',
    icon: [AllActive, AllInActive],
  },
];

function ResourceSelector(props) {
  const { classes, activeTab, clickHandler } = props;

  const trackEvent = value => {
    MixPanel.track('Homepage - Resource Carousel Filter Clicked', {
      type: value,
    });
    clickHandler(value);
  };
  const bot = isBot();
  return (
    <>
      <Hidden smDown>
        <Grid
          container
          justify="center"
          alignItems="center"
          className={classes.root}
        >
          <ul className={classes.listWrapper}>
            {Menu.map(({ label, icon }) => {
              const isActive = label === activeTab;
              const itemIcon = isActive ? icon[0] : icon[1];
              return (
                <li
                  key={label}
                  className={isActive ? classes.activeMenu : undefined}
                >
                  <ButtonBase
                    disableRipple
                    className={ClassNames(
                      classes.btn,
                      isActive ? classes.activeBtn : undefined,
                    )}
                    onClick={() => trackEvent(label)}
                  >
                    {!bot && (
                      <img
                        src={itemIcon}
                        alt={`${label} Icon`}
                        className={classes.icon}
                      />
                    )}
                    {label}
                  </ButtonBase>
                </li>
              );
            })}
          </ul>
        </Grid>
      </Hidden>
      <Hidden mdUp>
        <ResourcesTypeSelector
          options={Menu}
          activeTab={activeTab}
          clickHandler={clickHandler}
        />
      </Hidden>
    </>
  );
}

ResourceSelector.propTypes = {
  classes: PropTypes.object,
  activeTab: PropTypes.string,
  clickHandler: PropTypes.func,
};

export default withStyles(styles)(ResourceSelector);
